import { render, staticRenderFns } from "./form-body.vue?vue&type=template&id=4210c060&scoped=true&"
import script from "./form-body.vue?vue&type=script&lang=ts&"
export * from "./form-body.vue?vue&type=script&lang=ts&"
import style0 from "./form-body.vue?vue&type=style&index=0&id=4210c060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4210c060",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VForm,VProgressLinear,VRow})
